import { SVGAttributes } from "react";

export default (props: SVGAttributes<any>) => {
  return (
    <>
      <svg {...props} width="5" height="16" viewBox="0 0 5 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 13.9993C0 15.0978 0.902216 16 2.00071 16C3.0992 16 4.00142 15.0978 4.00142 13.9993C4.00142 12.901 3.0992 11.9986 2.00071 11.9986C0.902216 11.9986 0 12.901 0 13.9993ZM0 2.36293C0 3.46142 0.902216 4.36364 2.00071 4.36364C3.0992 4.36364 4.00142 3.46142 4.00142 2.36293C4.00142 1.26466 3.0992 0.362215 2.00071 0.362215C0.902216 0.362215 0 1.26466 0 2.36293ZM2.00071 10.1811C0.902775 10.1811 0.000710182 9.27944 0.000710182 8.18111C0.000710182 7.08301 0.902611 6.18111 2.00071 6.18111C3.09881 6.18111 4.00071 7.08301 4.00071 8.18111C4.00071 9.27921 3.09881 10.1811 2.00071 10.1811Z"
          fill="#818C99"
        />
      </svg>
    </>
  );
};
